export const RPMBillings = (function () {
	"use strict";

	let mytap, castTabs;

	const doTab = (tabText) => {
		var allTabs = document.querySelectorAll(".cast-tabs .tab");
		var allLinks = document.querySelectorAll("a[data-tab]");
		tabText = tabText.toLowerCase();

		// Hide all links initially
		allLinks.forEach(function (link) {
			link.style.display = "none";
		});

		// Show the links that match the tab
		allLinks.forEach(function (link) {
			if (link.getAttribute("data-tab").toLowerCase().includes(tabText)) {
				link.style.display = "block";
			}
		});

		// Activate the tab that matches the tabText
		allTabs.forEach(function (tab) {
			let tabTarget = document.querySelector('*[data-tab-target="'+ tab.textContent +'"]');
			if (tab.textContent.toLowerCase().includes(tabText)) {
				tab.classList.add("active"); // activate tab
				tabTarget.classList.add('active');// activate section
			} else {
				tab.classList.remove("active");
				tabTarget.classList.remove('active');
			}
		});
	}

	const checkTabSituation = () => {
		let allTabs = castTabs.querySelectorAll(".tab");

		allTabs.forEach(function (tab) {
			tab.addEventListener("click", function (event) {
				doTab(this.textContent);
			});
		});

		// Set initial state based on URL hashtag or first tab, depending
		var firstTabText = allTabs[0].textContent;
		var currentURL = window.location.href;
		if (currentURL.indexOf("#") !== -1) {
			var hashtagValue = currentURL.substring(currentURL.indexOf("#") + 1);
			if (checkIfTabExists(hashtagValue)) {
				doTab(hashtagValue);
			} else {
				doTab(firstTabText);
			}
		} else {
			doTab(firstTabText);
		}
	}

	const init = () => {
		mytap = window.ontouchstart === null ? "touchstart" : "click";
		castTabs = document.querySelector(".cast-tabs");
		if( castTabs ) {
			checkTabSituation();
		}
	}

	// Legacy

	// function createNextPrevLinks() {
	// 	// Get all elements on the page with the class "rpmblock--billings__container"
	// 	const rpmblockBillingsContainers = document.querySelectorAll(
	// 		".rpmblock--billings__container"
	// 	);

	// 	// Loop through each rpmblock--billings__container
	// 	rpmblockBillingsContainers.forEach((container) => {
	// 		// Find the anchor tags inside each rpmblock--billings__container
	// 		const anchorTags = container.querySelectorAll(
	// 			".rpmblock--billings__each"
	// 		);
	// 		// Run the loop function on the anchor tags of each rpmblock--billings__container
	// 		anchorTagsLoop(anchorTags);
	// 	});
	// }

	// function anchorTagsLoop(anchorTags) {
	// 	anchorTags.forEach((anchorTag, index) => {
	// 		// Get the ID of the corresponding modal from the href attribute
	// 		// const modalId = anchorTag.getAttribute("href").substring(1);
	// 		const modalId = anchorTag.dataset.customOpen;
	// 		const modal = document.getElementById(modalId);

	// 		// Find the Previous Modal span and populate its data-slug attribute
	// 		const prevModal = modal.querySelector(".modal__nav-previous");
	// 		if (index > 0) {
	// 			const prevAnchorTag = anchorTags[index - 1];
	// 			// const prevModalId = prevAnchorTag.getAttribute("href").substring(1);
	// 			const prevModalId = prevAnchorTag.dataset.customOpen;
	// 			prevModal.textContent = "Previous Modal";
	// 			prevModal.setAttribute("data-slug", prevModalId);
	// 		} else {
	// 			// prevModal.textContent = ""; // No previous modal for the first anchor tag
	// 			prevModal.setAttribute("data-slug", "");
	// 			prevModal.classList.add("inactive");
	// 		}

	// 		// Find the Next Modal span and populate its data-slug attribute
	// 		const nextModal = modal.querySelector(".modal__nav-next");
	// 		if (index < anchorTags.length - 1) {
	// 			const nextAnchorTag = anchorTags[index + 1];
	// 			// const nextModalId = nextAnchorTag.getAttribute("href").substring(1);
	// 			const nextModalId = nextAnchorTag.dataset.customOpen;
	// 			nextModal.textContent = "Next Modal";
	// 			nextModal.setAttribute("data-slug", nextModalId);
	// 		} else {
	// 			// nextModal.textContent = ""; // No next modal for the last anchor tag
	// 			nextModal.setAttribute("data-slug", "");
	// 			nextModal.classList.add("inactive");
	// 		}
	// 	});
	// }

	return {
		init: init,
	};
})();
